import React from 'react';
import { useTheme } from '../../utils/ThemeSwitcher';

const SubTabs = ({ tabs, activeTab, onTabChange, isMobile = false, isSidePanelExpanded = true }) => {
  const { isDarkMode } = useTheme();

  const colors = {
    bg: isDarkMode ? 'rgba(13, 14, 14, 0.9)' : 'rgba(245, 245, 245, 0.9)',
    activeBg: isDarkMode ? 'rgba(85, 85, 85, 0.75)' : '#c7c7c7',
    activeText: isDarkMode ? '#E0E0E0' : '#000000',
    inactiveText: isDarkMode ? '#595959' : '#a9a9a9',
    border: isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
  };
  //primary: isDarkMode ? '#5f5f5f' : '#a8a8a8',
  return (
    <div style={{
      display: 'flex',
      justifyContent: isMobile ? 'flex-start' : 'center',
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      maxWidth: '100%',
      gap: isMobile ? '0px' : '4px',
      marginBottom: isMobile ? '20px' : '20px',
      position: 'relative',
      top: isMobile ? '72px' : '50px',
      left: isMobile ? '0px' : (isSidePanelExpanded ? '100px' : '0px'),
      transition: 'left 0.3s ease',
      zIndex: 98,
      paddingLeft: isMobile ? '8px' : '0',
      paddingRight: isMobile ? '8px' : '0',
    }}>
      <nav style={{
        display: 'flex',
        gap: isMobile ? '1px' : '4px',
        flexWrap: 'nowrap',
        flexShrink: 0,
        backgroundColor: colors.bg,
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderRadius: isMobile ? '14px' : '20px',
        padding: isMobile ? '3px 4px' : '4px 5px',
        border: `1px solid ${colors.border}`,
      }}>
        {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: isMobile ? '5px' : '8px',
                padding: isMobile ? '7px 10px' : '6px 14px',
                borderRadius: isMobile ? '11px' : '16px',
                border: 'none',
                backgroundColor: isActive ? colors.activeBg : 'transparent',
                color: isActive ? colors.activeText : colors.inactiveText,
                fontSize: isMobile ? '12px' : '12px',
                fontWeight: isActive ? '600' : '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap',
                flexShrink: 0,
                minHeight: isMobile ? '32px' : 'auto',
                WebkitTapHighlightColor: 'transparent',
                fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, sans-serif",
              }}
            >
              <Icon size={isMobile ? 13 : 14} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </nav>
      <style>{`
        div[style*="z-index: 98"]::-webkit-scrollbar { display: none !important; }
      `}</style>
    </div>
  );
};

export default SubTabs;